module.exports = __webpack_public_path__ + "static/img/1.bc68a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/1.png
// module id = vKvA
// module chunks = 0